// Offres commerciales MonTempsGagné — source unique de vérité pour l'affichage.
// (Aucun système de paiement connecté : ces valeurs sont purement commerciales.)

export const TEASER_ANNUAL_FROM = "À partir de 468 € HT / an";
export const TEASER_MONTHLY_FROM = "À partir de 39 € HT / mois";

export const OFFERS = [
  {
    id: "essentiel",
    name: "ESSENTIEL",
    promise: "Qualifiez vos demandes, préparez vos devis et facilitez la prise de rendez-vous.",
    promoBadge: "3 mois offerts",
    promoSub: "Jusqu'à 6 mois sous conditions",
    monthlyLabel: "49 € HT",
    suffix: "/ mois",
    annualPerMonth: "39 € HT",
    annualBilled: "facturés 468 € HT une fois par an",
    annualEconomy: "Économisez 120 € HT par rapport à 12 mensualités.",
    features: [
      "Formulaire de demande personnalisé",
      "Qualification des demandes clients",
      "Génération automatique de devis",
      "Règles tarifaires configurées selon l'activité",
      "Prise de rendez-vous",
      "Suivi des demandes",
      "Suivi des devis",
      "Tableau de bord professionnel",
      "Espace client / devis public",
      "Hébergement",
      "Mises à jour",
    ],
    cta: "Demander une démonstration",
    ctaHref: "/#evaluer",
  },
  {
    id: "pro",
    name: "PRO",
    promise: "Automatisez davantage votre suivi commercial.",
    promoBadge: "3 mois offerts",
    promoSub: "Jusqu'à 6 mois sous conditions",
    monthlyLabel: "79 € HT",
    suffix: "/ mois",
    annualPerMonth: "65 € HT",
    annualBilled: "facturés 780 € HT une fois par an",
    annualEconomy: "Économisez 168 € HT par rapport à 12 mensualités.",
    includes: "Tout ce qui est inclus dans Essentiel, plus :",
    features: [
      "Relances automatisées",
      "Priorisation des demandes",
      "Règles de suivi personnalisées",
      "Automatisations métier avancées",
      "Workflows adaptés à l'entreprise",
      "Personnalisation avancée",
      "Connexions avec certains outils professionnels",
      "Accompagnement au paramétrage",
    ],
    note: "Certaines automatisations avancées sont déployées progressivement et incluses dans l'accompagnement au paramétrage.",
    cta: "Demander une démonstration",
    ctaHref: "/#evaluer",
    highlight: true,
  },
  {
    id: "nenzio",
    name: "NENZIO",
    subtitle: "Le copilote IA de MonTempsGagné",
    badge: "Bientôt disponible",
    promise: "Un copilote IA pour vous accompagner dans le pilotage quotidien de votre activité.",
    prefix: "À partir de",
    monthlyLabel: "129 € HT",
    suffix: "/ mois",
    annualPerMonth: "109 € HT",
    annualBilled: "facturés 1 308 € HT une fois par an",
    annualEconomy: "Économisez 240 € HT à ce tarif de départ.",
    features: [
      "Assistant IA conversationnel",
      "Résumé quotidien de l'activité",
      "Analyse des demandes",
      "Analyse des devis",
      "Analyse des rendez-vous",
      "Identification des priorités",
      "Détection des devis à relancer",
      "Suivi des actions importantes",
      "Connexion aux outils métier",
      "Pilotage par la voix",
      "Actions à la demande",
      "Automatisations personnalisées",
    ],
    cta: "Être informé du lancement",
    ctaHref: "/#evaluer",
    dark: true,
    unavailable: true,
  },
];
